import { useParams } from '@tanstack/react-router';

import { OBJECT_TYPE_ASSETS } from '@iconik-io/iconik-api/src/types/object_types';

import { Link } from '../../components/link/link';
import NoContentPanel from '../../components/no_content_panel/no_content_panel';
import { FACE_RECOGNITION_TRIGGER_CONFIRM_MODAL } from '../../constants/modals';
import { openModal } from '../../ducks/modals_manager/slice';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';
import { selectUserRoles } from '../../utils/get_user_roles';

import emptyFaceRecognitionSvg from '../../images/empty_face_recognition_list.svg';

import styles from './empty_face_recognition_panel.module.css';

export function EmptyFaceRecognitionPanel() {
  const dispatch = useAppDispatch();
  const userRoles = useAppSelector(selectUserRoles);
  const { id: assetId } = useParams({ strict: false });
  const asset = useAppSelector((state) =>
    assetId ? state.entities.assets[assetId] : undefined,
  );
  const isAdmin = useAppSelector(
    (state) => state.authReducer.userData.is_admin,
  );
  const isFaceRecognitionEnabled = useAppSelector(
    (state) => state.settings.merged.enable_face_recognition,
  );

  if (!isFaceRecognitionEnabled) {
    const actionElement = isAdmin ? (
      <Link to="/admin/face_recognition/settings" className={styles.link}>
        Enable in Face Recognition settings
      </Link>
    ) : (
      <div>
        Contact the domain administrator
        <br />
        to enable Face Recognition
      </div>
    );
    return (
      <NoContentPanel
        imageSrc={emptyFaceRecognitionSvg}
        title="No persons detected"
        actionElement={actionElement}
      />
    );
  }

  return (
    <NoContentPanel
      imageSrc={emptyFaceRecognitionSvg}
      title="No persons detected"
      actionText="Detect persons"
      disableActionButton={!userRoles.canTriggerFaceRecognition}
      onActionClick={() => {
        if (!asset) {
          return;
        }
        dispatch(
          openModal({
            id: FACE_RECOGNITION_TRIGGER_CONFIRM_MODAL,
            contextItems: [{ ...asset, object_type: OBJECT_TYPE_ASSETS }],
          }),
        );
      }}
    />
  );
}
